import { render, staticRenderFns } from "./car-color.vue?vue&type=template&id=faac1186&scoped=true&"
import script from "./car-color.vue?vue&type=script&lang=js&"
export * from "./car-color.vue?vue&type=script&lang=js&"
import style0 from "./car-color.vue?vue&type=style&index=0&id=faac1186&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faac1186",
  null
  
)

export default component.exports